import React, {useState, useEffect} from "react";
import Navigation from '../Navigation';
import CarrierMap from './CarrierMap';
import Map from '../Map';
import ControlPanel from './CarrierControlPanel';
import { useCheckboxState } from 'pretty-checkbox-react';
import {carriers} from '../../lib/carriers';
import dateFormat from "dateformat";
import { useRequest } from "../../lib/hooks";
import {getCoordinatesFromStringPoint, parseCellSignals} from '../../lib/geo';
import { userLogin } from "../../reducers/UserSlice";
import {getComparisonCellSignalIds} from "./util";
import { useHistory } from "react-router-dom";
import {carrierStats} from '../../lib/carrier-analytics';

function CarrierPanel(){

    const dateModeCheckbox = useCheckboxState();
    const [dateMode, setDateMode] = useState(false);

    const [cellSignals, setIdFilteredCellSignals] = useState([]);
    
    const [filters, setFilters] = useState({
        signalTypes: ['NrSignal', 'CdmaSignal', 'WcdmaSignal', 'GsmSignal', 'LteSignal'],
        carriers: ['at-t','verizon','t-mobile'],
        strengths: ['poor' ,'fair', 'good', 'best'],
        startDate: (new Date(Date.now() - + 7 * 24 * 60 * 60 * 1000)),
        endDate: (new Date())
    });
    let history = useHistory();
    const {axiosWrapper, dispatch, jwts, user} = useRequest();

    const [viewport, setViewport] = useState({
        width: "100%",
        height: "95vh",
        latitude: user.attributes?.institutionCenter?.length > 0 ? getCoordinatesFromStringPoint(user?.attributes.institutionCenter)[1] : null, 
        longitude: user.attributes?.institutionCenter?.length > 0 ? getCoordinatesFromStringPoint(user?.attributes.institutionCenter)[0] : null,
        zoom: 10,
    });

    function setCellSignals(newCellSignals){
        const uniqueIds = [];
        const filteredSignals = newCellSignals.filter(signal =>{

            const isDuplicate = uniqueIds.includes(signal.id);

            if (!isDuplicate) {
                uniqueIds.push(signal.id);

                return true;
            }

            return false;
        })

        setIdFilteredCellSignals(filteredSignals);
    }

    const addSignals = (lat, lon)=>{
        let dateQuery = ''
        if(dateMode){
            try{
                const earlierDate = filters.startDate < filters.endDate ? filters.startDate : filters.endDate;
                const laterDate = filters.startDate > filters.endDate ? filters.startDate : filters.endDate;
                const earlierDateQuery = dateFormat(earlierDate, "mm-dd-yyyy");
                const laterDateQuery = dateFormat(laterDate, "mm-dd-yyyy");
                dateQuery = `&start-date=${earlierDateQuery}&end-date=${laterDateQuery}`;
            }catch(e){
                console.log('error setting up date query', e);
            }
        }
            axiosWrapper({
                method: 'get',
                accessToken: jwts?.accessToken,        
                refreshToken: jwts?.refreshToken,
                url: `/cell-signals?lat=${lat}&lon=${lon}${dateQuery}`
            }, dispatch)
                .then(({data})=>{
                    console.log('BASED 4', data.cellSignals);
                    setCellSignals([...cellSignals, ...parseCellSignals(data.cellSignals)
                    ]);
                })
                .catch(e =>{
                    console.log('error getting cell signals', e)
    
                });
    }

    useEffect(()=>{
        try{            
            if(user?.attributes?.institutionCenter){
                const [lon, lat] = getCoordinatesFromStringPoint(user.attributes.institutionCenter)

                if(lat && lon){
                    setViewport({
                        width: "100%",
                        height: "95vh",
                        latitude: lat, 
                        longitude: lon,
                        zoom: 10,        
                    });
                }
            }else{
                axiosWrapper({
                    method: 'get',
                    accessToken: jwts?.accessToken, 
                    refreshToken: jwts?.refreshToken,               
                    url: '/user-data'
                }, dispatch)
                .then(({data}) => {
                    const {userData} = data;
                    dispatch(userLogin({userData}));
                })
                .catch(e => {
                    console.log('error getting user-data', e)
                })
            }
            
            
            
        }catch(e){
            console.log('ERROR SETTING', e)
        }

    }, [user])

    useEffect(()=>{
        if(dateModeCheckbox.state){
            
        }else{
            if(dateMode & viewport.latitude & viewport.longitude){
                axiosWrapper({
                    method: 'get',
                    accessToken: jwts?.accessToken, 
                    refreshToken: jwts?.refreshToken,               
                    url: `/cell-signals?lat=${viewport.latitude}&lon=${viewport.longitude}`
                }, dispatch)
                .then(({data}) => {
                    console.log('BASED 1', data.cellSignals);
                  setCellSignals([...parseCellSignals(data.cellSignals)]);
                })
                .catch(e => {
                    console.log('error getting cell signals', e)
                })
                setDateMode(false);
            }
        }
        
        return () =>{

        }
    }, [dateModeCheckbox, jwts, user])

    const handleDateModeEnter = (startDate, endDate)=>{
        
        const newFilters = filters;
        newFilters.startDate = startDate;
        newFilters.endDate = endDate;

        const earlierDate = startDate < endDate ? startDate : endDate;
        const laterDate = startDate > endDate ? startDate : endDate;
        setFilters({...newFilters})
        setDateMode(true);
        if(viewport.latitude && viewport.longitude){
            axiosWrapper({
                method: 'get',
                accessToken: jwts?.accessToken,        
                refreshToken: jwts?.refreshToken,
                url: `/cell-signals?start-date=${dateFormat(earlierDate, "mm-dd-yyyy")}&end-date=${dateFormat(laterDate, "mm-dd-yyyy")}&lat=${viewport.latitude}&lon=${viewport.longitude}`
            }, dispatch)
                .then(({data})=>{
                    console.log('BASED 2', data.cellSignals);
                    setCellSignals([...parseCellSignals(data.cellSignals)]);
                })
                .catch(e =>{
                    console.log('error getting cell signals', e)
    
                });
        }
        
    }

    useEffect(() => {

        if(viewport.latitude && viewport.longitude && jwts){
            axiosWrapper({
                method: 'get',
                accessToken: jwts?.accessToken,
                refreshToken: jwts?.refreshToken,    
                url: `/cell-signals?lat=${viewport.latitude}&lon=${viewport.longitude}`
            }, dispatch)
              .then(({data}) => {
                setCellSignals([...parseCellSignals(data.cellSignals)]);
              })
              .catch(e => {
                  console.log('error getting cell signals', e)
              })    
        }
      return () => {
          //cleanup
      }
    }, [jwts, user])

    const analyzeCarriers = ()=>{
        return new Promise((resolve, reject)=>{
            try {
                const ids = getComparisonCellSignalIds(cellSignals, viewport.latitude, viewport.longitude, viewport.zoom);
                axiosWrapper({
                    method: 'post',
                    accessToken: jwts?.accessToken,
                    refreshToken: jwts?.refreshToken,    
                    url: `/cell-signals-multi`,
                    data: {ids: ids}
                }, dispatch, history)
                  .then(({data}) => {
                    const result = carrierStats(data.cellSignals);
                    resolve(result);
                  })
                  .catch(e => {
                    console.log('error sending cell signal multi-show request', e);
                    //reject(e);
                    throw e;
                  })  
            }catch(e) {
                reject(e);
            }
        })
    }

    return (
       <div className='admin-panel-container'>
            <Navigation />
            <div className='map-section' style={{minHeight: "95vh"}}>
                <div className='map' style={{minHeight: "95vh"}}>
                    {viewport.longitude ? <Map 
                        data={cellSignals} 
                        filters={filters}
                        startingPoint={user?.attributes?.institutionCenter} 
                        mode='cell-signals'
                        addSignals={addSignals}
                        viewport={viewport}
                        setViewport={setViewport}
                        centerRectangle={true}
                    /> : null}
                </div>
                <ControlPanel
                    analyzeCarriers={analyzeCarriers}
                    filters={filters}
                    setFilters={setFilters}
                    dateModeCheckbox={dateModeCheckbox}
                    dateMode={dateMode}
                    handleDateModeEnter={handleDateModeEnter}
                />
            </div>
            <div className="divider"></div>
        </div>
    )
}

export default CarrierPanel;